/* eslint-disable no-empty */
import _ from 'lodash';
import { NextSeo } from 'next-seo';
import dynamic from 'next/dynamic';
import Head from 'next/head';
import styled from 'styled-components';

import {
  APP_IMG,
  APP_URL,
  IS_NO_ROBOT_INDEX,
  NEXT_PUBLIC_SPEED_KEYPOINT,
  NEXT_PUBLIC_URL_SOUND,
  NEXT_PUBLIC_WEB_NAME_SOUND,
  SHOW_COMMEMORATE
} from 'src/constants';
import { convertObjPath, escapeChar, htmlToPlainText, rewriteTxt, timestamp, useDateUpdate } from 'src/utils/helper';
// import { APP_IMG, APP_URL, IS_NO_ROBOT_INDEX, NEXT_PUBLIC_SPEED_KEYPOINT, NEXT_PUBLIC_URL_SOUND, NEXT_PUBLIC_WEB_NAME_SOUND, SHOW_COMMEMORATE } from 'src/constants';

import axios from 'axios';
import { useRouter } from 'next/router';
import { useEffect, useRef, useState } from 'react';
import { IoIosShareAlt } from 'react-icons/io';
import { useMediaQuery } from 'react-responsive';
import { SectionHead } from 'src/components/cards';
import WidgetStickyContents from 'src/components/translates/widget-sticky-contents';
import WidgetRollBack from 'src/components/widgets/widget-rollback';
import { IMAGE_DEFAULT, WEB_DESC, WEB_KEYWORD, WEB_LOGO, WEB_NAME, WEB_TITLE, WEB_URL } from 'src/constants/layout';
import { decryptionClient } from 'src/services/member-auth/utils/decryption-payload';
import { KEY_ADS_POSITION } from 'src/utils/ads/dynamic-ads';
import { getAffiliate, getFeatureImage, setContents } from 'src/utils/contents';
import { incrementCountview } from 'src/utils/countview';
import { DATALAYER_TYPE, sendDataLayerGlobal } from 'src/utils/datalayer/send-datalayer';
import { convertDatasets } from 'src/utils/datasets';
import { useDesktop } from 'src/utils/device';
import { GET, GET_ARTICLES } from 'src/utils/services';
import useUser from 'src/utils/useUser';

const AdsNative = dynamic(import('src/utils/ads/ads-native'), { ssr: false });
const StickyBox = dynamic(import('react-sticky-box'));
const EmptyArticle = dynamic(import('src/components/empty'));
const Layout = dynamic(import('src/components/layouts'));
const Carousels = dynamic(import('src/components/carousels'));
const CardH = dynamic(import('src/components/cards/card-h'));
const CardV = dynamic(import('src/components/cards/card-v'));
const WidgetShareArticle = dynamic(import('src/components/widgets/widget-share-article'));
const WidgetBreadcrumb = dynamic(import('src/components/widgets/widget-breadcrumb'));
const WidgetSocialShare = dynamic(import('src/components/widgets/widget-social-share'));
const DynamicAds = dynamic(import('src/utils/ads/dynamic-ads'));
const SectionAffiliate = dynamic(import('src/components/sections/section-event/section-affiliate'));

const PageDetail = ({ article, ads, mostview, related, solrRelated, dataAffiliate, dataAdsNative, wrapSectionImage, wrapSectionLink, agent }) => {
  const _data = useUser();
  const sessionSevId = _data?.user ? decryptionClient(_data?.user) : null;
  if (_.isEmpty(article)) return <EmptyArticle sessionSevId={sessionSevId} />;
  const [adsBox, setAdsBox] = useState(true);
  /* -------------------------------- AI ------------------------------- */
  const [isKeyPoint, setIsKeyPoint] = useState(true);
  const [selectLang, setSelectLang] = useState('TH');
  const [isLoading, setIsLoading] = useState(false);
  const [newsArticle, setNewsArticle] = useState({ ...article });
  const [isTranslate, setIsTranslate] = useState(false);

  const handleLightBoxClick = () => {
    setAdsBox(false);
  };
  const router = useRouter();
  const footerRef = useRef(false);
  const sectionRef = useRef(null);
  const isDesktop = useDesktop();

  const checkRouteInfographic = router?.query?.cid === 'infographic';
  const checkRouteInfographicSubcategory = router?.query?.cid === 'news';
  const checkRouteInfographicSubcategoryArticle = article?.subCategory?.en === 'infographic';
  const checkPathInfo = (checkRouteInfographicSubcategory && checkRouteInfographicSubcategoryArticle) || checkRouteInfographic;

  const checkRouteNationStory = router?.query?.cid === 'nation-story';
  const checkRouteNationStorySubcategory = router?.query?.cid === 'news';
  const checkRouteNationStorySubcategoryArticle = article?.subCategory?.en === 'nation-story';
  const checkPathNationStory = (checkRouteNationStorySubcategory && checkRouteNationStorySubcategoryArticle) || checkRouteNationStory;

  const _article = {
    ...article,
    ...newsArticle,
    id: newsArticle?.id,
    link: newsArticle?.link,
    tags: newsArticle?.tags,
    section: newsArticle?.section,
    image_url: newsArticle?.meta?.og_social_image,
    subCategory: newsArticle?.subCategory,
    title: newsArticle?.title ?? article?.meta?.title ?? WEB_TITLE,
    description: newsArticle?.meta?.description || WEB_DESC,
    keyword: newsArticle?.meta?.keyword || WEB_KEYWORD,
    imageUrl: newsArticle?.meta?.og_social_image || IMAGE_DEFAULT
  };
  const baseUrlCategory = `${APP_URL}${_article?.link}`;
  /* ----------------------------------- SEO ---------------------------------- */
  const articleTitleSeo = escapeChar(_article?.title) || WEB_TITLE;
  const articleDescriptionSeo = escapeChar(_article?.description) || WEB_DESC;
  // const [countView, setCountView] = useState(_article?.pageviews || 0);
  /* -------------------------------------------------------------------------- */

  /* -------------------------------- AI ------------------------------- */

  const handleTranslate = async newLanguage => {
    try {
      setSelectLang(newLanguage);
      setIsLoading(true);
      setIsTranslate(!isTranslate);
      setIsKeyPoint(false);
      if (NEXT_PUBLIC_URL_SOUND !== undefined || !_.isEmpty(_article?.id)) {
        const uriToken = `${NEXT_PUBLIC_URL_SOUND}/create`;
        const getToken = await axios
          .post(
            uriToken,
            {
              app: 'default'
            },
            {
              headers: {
                'Content-Type': 'application/json',
                'User-Agents': `NationSpeech/1.0 ${agent}`
              }
            }
          )
          .catch(error => {
            console.error(error);
          });

        // console.log({ getToken });
        if (getToken?.data?.data?.token !== undefined) {
          const uriEn = `${NEXT_PUBLIC_URL_SOUND}/translates/${_article?.id}/${newLanguage}`;
          // console.log('uriEn', uriEn);

          const translate = await axios
            .post(
              uriEn,
              {
                data: {
                  id: _article?.id,
                  site: NEXT_PUBLIC_WEB_NAME_SOUND,
                  language: newLanguage
                }
              },
              {
                headers: {
                  'Content-Type': 'application/json',
                  'User-Agents': `NationSpeech/1.0 ${agent}`,
                  accessToken: getToken?.data?.data?.token,
                  accessTimeStamp: getToken?.data?.data?.timestamp
                }
              }
            )
            .catch(error => {
              console.error(error);
            });
          await new Promise(resolve => setTimeout(resolve, 500));
          setNewsArticle({
            ...article,
            ...translate?.data?.data
          });
        }
      }
    } catch (error) {
      setIsLoading(true);
      console.log(error, 'Error Translate ');
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const keypointContent = document.getElementById('keypoint-content') ?? null;
    while (keypointContent?.firstChild) {
      keypointContent?.removeChild(keypointContent?.firstChild);
    }

    if (isKeyPoint === true && !_.isEmpty(_article?.key_point)) {
      const element = document.getElementById('feature-image');
      element?.scrollIntoView({ behavior: 'smooth', top: 0 });

      const div = document.createElement('div');
      div.innerHTML = _article?.key_point || '';

      const strongElements = div.getElementsByTagName('strong');
      for (let i = 0; i < strongElements.length; i++) {
        strongElements[i].style.fontWeight = 'bold';
      }

      const speed = NEXT_PUBLIC_SPEED_KEYPOINT ?? 50;

      let txt = _article?.key_point;
      let i = 0;

      txt = htmlToPlainText(txt?.replace(/<\/?[^>]+(>|$)/g, match => (match === '<li>' ? '_' : '')));

      const ul = document.createElement('ul');
      let li = document.createElement('div');

      const intervalId = setInterval(() => {
        if (i < txt.length) {
          const char = txt.charAt(i);
          if (char === '_') {
            keypointContent?.appendChild(ul);
            li = document.createElement('li');
            // Create a new li element for the next line
            keypointContent?.appendChild(li);
            ul.appendChild(li);
            i++;
          } else {
            li.innerHTML += char;
            i++;
          }
        }
        // else {
        //     clearInterval(intervalId);
        // }
      }, speed);

      return () => clearInterval(intervalId);
    }
  }, [isKeyPoint]);
  useEffect(() => {
    /* ------------------------------ INCREAMENT_COUNTVIEW ----------------------------- */
    (async () => {
      try {
        await incrementCountview(_article);
      } catch (err) {
        console.error(`${timestamp()} ==========> CARD_FEATURE ERROR :`, err.message);
      }
    })();
    /* ------------------------------- SET_CONTENT ------------------------------ */
    setContents();
  }, []);

  // ACCEPT COOKIE ********************************
  const handleScrollAdsPostArticle = () => {
    const sectionEl = document.getElementById('cookie');
    const sticky = document.querySelector('.sticky-cookie');
    // const cookies = document.querySelector('.displayC');
    if (sectionEl !== null) {
      if (sectionEl.offsetTop < document.documentElement.scrollTop + 400) {
        if (sticky) {
          sticky.style.display = 'block';
        }
        // cookies.style.display = 'none';
      } else {
        if (sticky) {
          sticky.style.display = 'none';
        }
        // cookies.style.display = 'unset';
      }
    }
  };

  useEffect(() => {
    document.addEventListener('scroll', handleScrollAdsPostArticle);
    return () => document.removeEventListener('scroll', handleScrollAdsPostArticle);
  });
  /* -------------------------------- DATALAYER ------------------------------- */
  const handleParagraphOne = async () => {
    const sectionEl = await document.getElementById('paragraph-1');

    if (sectionEl) {
      if (sectionEl.offsetTop < document.documentElement.scrollTop) {
        sectionRef.current = 'paragraph-1';

        document.removeEventListener('scroll', handleParagraphOne);
        await sendDataLayerGlobal({
          type: DATALAYER_TYPE.TRACK_SCROLL,
          router: router?.pathname,
          section: 'scroll',
          data: {
            title: router.asPath,
            heading: 'paragraph-1'
          }
        });
      }
    }
  };
  const handleParagraphTwo = async () => {
    const sectionEl = await document.getElementById('paragraph-2');

    if (sectionEl) {
      if (sectionEl.offsetTop < document.documentElement.scrollTop) {
        sectionRef.current = 'paragraph-2';
        document.removeEventListener('scroll', handleParagraphTwo);
        await sendDataLayerGlobal({
          type: DATALAYER_TYPE.TRACK_SCROLL,
          router: router?.pathname,
          section: 'scroll',
          data: {
            title: router.asPath,
            heading: 'paragraph-2'
          }
        });
      }
    }
  };

  const handleParagraphThree = async () => {
    const sectionEl = await document.getElementById('paragraph-3');
    if (sectionEl) {
      if (sectionEl.offsetTop < document.documentElement.scrollTop) {
        sectionRef.current = 'paragraph-3';
        document.removeEventListener('scroll', handleParagraphThree);
        await sendDataLayerGlobal({
          type: DATALAYER_TYPE.TRACK_SCROLL,
          router: router?.pathname,
          section: 'scroll',
          data: {
            title: router.asPath,
            heading: 'paragraph-3'
          }
        });
      }
    }
  };

  const handleScrollToReadComplete = async () => {
    const sectionEl = await document.getElementById('section-ads');
    if (sectionEl !== null) {
      if (sectionEl.offsetTop < document.documentElement.scrollTop) {
        sectionRef.current = 'section-ads';
        if (!isNaN(localStorage.getItem('_t'))) {
          const counter = parseInt(localStorage.getItem('_t'));
          const toArray = num => num && [...`${num}`].map(elem => parseInt(elem));
          const _a = toArray(counter)[toArray(counter).length - 1] === 0 ? 0 : 1;
          const _b = counter - 1;
          const start = Math.floor((_a === 0 ? _b : counter) / 10) * 10;
          const end = Math.ceil(counter / 10) * 10;
          const first = start === 0 ? 1 : start + 1;
          const second = end === 0 ? 10 : end;
          const timer = `${first}-${second}`;

          document.removeEventListener('scroll', handleScrollToReadComplete);
          await sendDataLayerGlobal({
            type: DATALAYER_TYPE.TRACK_READTIME,
            router: router?.pathname,
            section: 'scroll',
            data: {
              title: router.asPath,
              heading: 'read-complete',
              time: timer
            }
          });
          await localStorage.removeItem('_t');
        } else {
          document.removeEventListener('scroll', handleScrollToReadComplete);
          await sendDataLayerGlobal({
            type: DATALAYER_TYPE.TRACK_READTIME,
            router: router?.pathname,
            section: 'scroll',
            data: {
              title: router.asPath,
              heading: 'read-complete',
              time: '1-10'
            }
          });
          await localStorage.removeItem('_t');
        }
      }
    }
  };

  const handleScrollToSectionAds = async () => {
    const sectionEl = await document.getElementById('section-ads');
    if (sectionEl !== null) {
      if (sectionEl.offsetTop < document.documentElement.scrollTop) {
        sectionRef.current = 'section-ads';
        document.removeEventListener('scroll', handleScrollToSectionAds);
        await sendDataLayerGlobal({
          type: DATALAYER_TYPE.TRACK_SCROLL,
          router: router?.pathname,
          section: 'scroll',
          data: {
            title: router.asPath,
            heading: 'section-ads'
          }
        });
        footerRef.current = true;
      }
    }
  };
  const handleScrollToSectionFooter = async () => {
    const sectionEl = await document.getElementById('footer-wrapper');
    if (footerRef.current) {
      if (sectionEl?.offsetTop < document.documentElement.scrollTop + 500) {
        document.removeEventListener('scroll', handleScrollToSectionFooter);
        await sendDataLayerGlobal({
          type: DATALAYER_TYPE.TRACK_SCROLL,
          router: router?.pathname,
          section: 'scroll',
          data: {
            title: router.asPath,
            heading: 'footer-wrapper'
          }
        });
      }
    }
  };

  useEffect(() => {
    try {
      // SETUP SESSION, AUHT, LOCALE, SETTINGS ETC
      localStorage?.setItem('_t', 0);
      const increment = () => {
        const count = localStorage.getItem('_t');
        const time = parseInt(count);
        localStorage.setItem('_t', time + 1);
      };
      setInterval(increment, 1000);
    } catch (err) {
      // PROVIDE FEEDBACK TO THE USER
      console.log('Error: Please enable website cookies. ' + err);
    }
  }, []);

  useEffect(() => {
    document.addEventListener('scroll', handleParagraphOne);
    return () => document.removeEventListener('scroll', handleParagraphOne);
  }, []);

  useEffect(() => {
    document.addEventListener('scroll', handleParagraphTwo);
    return () => document.removeEventListener('scroll', handleParagraphTwo);
  }, []);

  useEffect(() => {
    document.addEventListener('scroll', handleParagraphThree);
    return () => document.removeEventListener('scroll', handleParagraphThree);
  }, []);

  useEffect(() => {
    document.addEventListener('scroll', handleScrollToReadComplete);
    return () => document.removeEventListener('scroll', handleScrollToReadComplete);
  }, []);

  useEffect(() => {
    document.addEventListener('scroll', handleScrollToSectionAds);
    return () => document.removeEventListener('scroll', handleScrollToSectionAds);
  }, []);

  useEffect(() => {
    document.addEventListener('scroll', handleScrollToSectionFooter);
    return () => document.removeEventListener('scroll', handleScrollToSectionFooter);
  }, []);

  // handleCommemorate
  function getScrollTop() {
    if (typeof window.pageYOffset !== 'undefined') {
      // Most browsers
      return window.pageYOffset;
    }

    const d = document.documentElement;
    if (typeof d.clientHeight !== 'undefined') {
      // IE in standards mode
      return d.scrollTop;
    }

    // IE in quirks mode
    return document.body.scrollTop;
  }
  const isMb = useMediaQuery({ query: '(max-width: 1023px)' });
  useEffect(() => {
    if (isMb) {
      window.onscroll = function () {
        const box = document.getElementById('widget-group-js');
        if (!_.isEmpty(box)) {
          const scroll = getScrollTop();
          if (scroll <= 0) {
            box.style.top = '150px';
          } else {
            box.style.top = 150 + scroll + 2 + 'px';
          }
        }
      };
    }
  }, []);
  // handleCommemorate
  return (
    <>
      {/* -------------------------------- NEXT_SEO -------------------------------- */}
      <NextSeo
        noindex={IS_NO_ROBOT_INDEX}
        nofollow={IS_NO_ROBOT_INDEX}
        title={_article?.title || WEB_TITLE}
        description={_article?.description || WEB_DESC}
        openGraph={{
          type: 'article',
          locale: 'th_TH',
          site_name: WEB_NAME,
          title: _article?.title || WEB_TITLE,
          description: _article?.description || WEB_DESC,
          url: baseUrlCategory,
          article: {
            publishedTime: _article?.published_at,
            modifiedTime: _article?.updated_at,
            expirationTime: null,
            section: _article?.section?.th,
            authors: [`${WEB_URL.FACEBOOK}`],
            tags: _article?.tags
          },
          images: [
            {
              url: _article?.image_url,
              width: '700',
              height: '395',
              alt: _article?.title || WEB_TITLE
            }
          ]
        }}
        additionalMetaTags={[
          {
            name: 'keywords',
            content: _article?.keyword || WEB_KEYWORD
          }
        ]}
      />
      {/* --------------------------------- HEADER --------------------------------- */}
      <Head>
        <link rel='canonical' href={`${_article?.canonical}`} />
        <meta property='twitter:title' content={_article?.title || WEB_TITLE} />
        <meta property='twitter:description' content={_article?.description || WEB_DESC} />
        <meta property='twitter:image' content={_article?.image_url || IMAGE_DEFAULT} />

        {/* --------------------------- SCRIPT ADS ------------------------------ */}
        {!_.isEmpty(ads) && article.is_show_ads && (
          <>
            <script async type='text/javascript' src='https://securepubads.g.doubleclick.net/tag/js/gpt.js' />
            <script
              type='text/javascript'
              dangerouslySetInnerHTML={{
                __html: 'var googletag = googletag || {}; window.googletag.cmd = googletag.cmd || [];'
              }}
            />
          </>
        )}

        {/* ------------------------------- Truehit -------------------------------- */}
        <script
          type='text/javascript'
          dangerouslySetInnerHTML={{
            __html: `
                    __th_page="${_article?.section?.en}";
                  `
          }}
        />

        {/* ---------------------------- SNIPPET : WebSite --------------------------- */}
        <script
          type='application/ld+json'
          dangerouslySetInnerHTML={{
            __html: `
                    {
                      "@context": "https://schema.org",
                      "@type": "WebSite",
                      "name": "${WEB_NAME}",
                      "url": "${WEB_URL.WEB}",
                      "description": "${articleDescriptionSeo}",
                      "sameAs": [
                        "${WEB_URL.FACEBOOK}",
                        "${WEB_URL.YOUTUBE}",
                        "${WEB_URL.INSTAGRAM}",
                        "${WEB_URL.TWITTER}",
                        "${WEB_URL.LINE}"
                      ],
                      "potentialAction": {
                        "@type": "SearchAction",
                        "target": "${WEB_URL.WEB}search?q={search_term_string}",
                        "query-input": "required name=search_term_string"
                      }
                    }
                  `
          }}
        />

        {/* ---------------------------- SNIPPET : WebPage --------------------------- */}
        <script
          type='application/ld+json'
          dangerouslySetInnerHTML={{
            __html: ` 
                    { 
                      "@context": "http://schema.org", 
                      "@type": "WebPage", 
                      "name": "${articleTitleSeo}", 
                      "description": "${articleDescriptionSeo}", 
                      "publisher": { 
                        "@type": "ProfilePage", 
                        "name": "${WEB_NAME}" 
                      } 
                    } 
                  `
          }}
        />

        {/* ------------------------ SNIPPET : BreadcrumbList ------------------------ */}
        <script
          type='application/ld+json'
          dangerouslySetInnerHTML={{
            __html: ` 
                    { 
                      "@context": "http://schema.org", 
                      "@type": "BreadcrumbList", 
                      "itemListElement": [ 
                        { 
                          "@type": "ListItem", 
                          "position": 1, 
                          "name": "หน้าแรก", 
                          "item": "${APP_URL}" 
                        }, 
                        { 
                          "@type": "ListItem", 
                          "position": 2, 
                          "name": "${_article?.section?.th}", 
                          "item": "${APP_URL}/${_article?.section?.en}" 
                        }, 
                        { 
                          "@type": "ListItem", 
                          "position": 3, 
                          "name": "${articleTitleSeo}", 
                          "item": "${_article?.canonical || `${APP_URL}${_article?.link}`}"
                        } 
                      ] 
                    } 
                  `
          }}
        />

        {/* -------------------------- SNIPPET : NewsArticle ------------------------- */}
        <script
          type='application/ld+json'
          dangerouslySetInnerHTML={{
            __html: ` 
                    { 
                      "@context": "http://schema.org", 
                      "@type": "NewsArticle", 
                      "mainEntityOfPage": { 
                        "@type": "WebPage", 
                        "@id": "${_article?.canonical || `${APP_URL}${_article?.link}`}"
                      }, 
                      "headline": "${articleTitleSeo}", 
                      "alternativeHeadline": "${articleTitleSeo}", 
                      "description": "${articleDescriptionSeo}", 
                      "image": "${APP_IMG}${_article?.image}", 
                      "datePublished": "${_article?.published_at}",
                      "dateModified": "${_article?.updated_at}",
                      "author": { 
                        "@type": "Thing", 
                        "name": "${_article.byline || WEB_NAME}",
                        "url": "${APP_URL}"
                      }, 
                      "publisher": { 
                        "@type": "Organization", 
                        "name": "${WEB_NAME}", 
                        "logo": { 
                          "@type": "ImageObject", 
                          "url": "${WEB_LOGO}" 
                        } 
                      } 
                    } 
                  `
          }}
        />
        {/* -------------------------------- ADS : Native (Mgid) ------------------------------- */}
        {/* {article.is_show_ads && dataAdsNative?.header && parse(dataAdsNative?.header || '')} */}
        {/* {article.is_show_ads && dataAdsNative == null && (
          <script
            src='https://jsc.mgid.com/s/p/springnews.co.th.1144486.js'
            async
          />
        )} */}

        {/* --------------------------- Social embed script -------------------------- */}
        <script async src='//www.instagram.com/embed.js' />
        <script async src='https://platform.twitter.com/widgets.js' />
      </Head>
      {!_.isEmpty(dataAffiliate) && <SectionAffiliate position={4} data={dataAffiliate} />}
      <Layout sessionSevId={sessionSevId}>
        <CategoryWrapper wrapSectionImage={wrapSectionImage}>
          <BreadcrumbWrapper className='breadcrumb-wrapper'>
            <WidgetBreadcrumb data={_article} />
          </BreadcrumbWrapper>
          <a className='click-image-wrap' href={wrapSectionLink} />
          <WidgetRollBack text='เลือกตั้ง 2566 อนาคตประเทศไทย' link={'#'} />

          <div className={'container bg-section'} style={{ filter: SHOW_COMMEMORATE === 'true' ? 'grayscale(1)' : 'unset' }}>
            {!_.isEmpty(ads) && <DynamicAds position={KEY_ADS_POSITION.LIGHTBOX} data={ads} handler={() => handleLightBoxClick()} adsBox={adsBox} />}
            {/* -------------------------- ADS-PPN : Billboard ------------------------------ */}
            {_article.is_show_ads && <DynamicAds position={KEY_ADS_POSITION.BILLBOARD} data={ads} />}
            <div className='article-area mt-0 mt-lg-30'>
              <div className='row'>
                {/* <div className='col-12 col-lg-1 position-relative position-md-unset p-0'>
                  <div
                    id={`${SHOW_COMMEMORATE === 'true' ? 'widget-group-js' : 'widget-group'}`}
                    className={`${SHOW_COMMEMORATE === 'true' ? 'position-sticky-left-content-js' : 'position-sticky-left-content'} back-drop`}
                  >
                    <WidgetSpeech
                      _id={article.id}
                      _data={article}
                      // ! DATALAYER
                      eventDataLayer={{
                        type: DATALAYER_TYPE.TRACK_POSITION,
                        router: router?.pathname,
                        section: 'ฟังข่าว',
                        position: 'ด้านซ้าย:content',
                        data: {
                          heading: 'ฟังข่าว'
                        }
                      }}
                    />
                    <WidgetShareStickySpeech
                      _data={article}
                      link={article.link}
                      // ! DATALAYER
                      eventDataLayer={{
                        type: DATALAYER_TYPE.TRACK_POSITION,
                        router: router?.pathname,
                        section: 'แชร์ข่าว',
                        position: 'ด้านซ้าย:content',
                        data: {
                          heading: 'แชร์ข่าว'
                        }
                      }}
                    />
                  </div>
                </div> */}
                {checkPathNationStory && (
                  <div className='category-nation-story-logo'>
                    <img src='https://image.springnews.co.th/images/logo-story.png' alt='Category Logo' className='logo-image' />
                  </div>
                )}
                <div className='col-12 col-lg-8 position-relative position-md-unset p-0'>
                  <div className='title-content'>
                    <h1 className='category'>{_article?.title}</h1>
                  </div>

                  <div className='post-info'>
                    <div className='meta'>
                      {_article?.byline && (
                        <div className='byline'>
                          <span className='by'>by</span>
                          <span>{_article?.byline}</span>
                        </div>
                      )}
                      {article?.published_at && (
                        <p className='date-time'>
                          <span>{useDateUpdate(article?.published_at, false)} </span>
                        </p>
                      )}
                      {/* {countView > 0 && <Viewer data={countView} />} */}
                    </div>
                    {!_.isEmpty(ads) && article?.is_video && (
                      <WidgetShareArticle
                        articleLink={article?.link}
                        round={true}
                        //! DATALAYER
                        eventDataLayer={{
                          type: DATALAYER_TYPE.TRACK_POSITION,
                          router: router?.pathname,
                          section: 'share',
                          position: 'after:ภาพปก'
                        }}
                      />
                    )}
                  </div>

                  <div className={`content-feature ${checkPathInfo ? 'infographic-image' : ''}`}>
                    {getFeatureImage(article, checkPathInfo)}
                    {!article?.is_video && (
                      <>
                        <div className='position-absolute share-card --desktop'>
                          <IoIosShareAlt />
                          <WidgetSocialShare
                            articleLink={article?.link}
                            //! DATALAYER
                            eventDataLayer={{
                              type: DATALAYER_TYPE.TRACK_POSITION,
                              router: router?.pathname,
                              section: 'share',
                              position: 'on:ภาพปก'
                            }}
                          />
                        </div>
                        <div className='share-card --mobile'>
                          {/* <IoIosUndo /> */}
                          <IoIosShareAlt />
                          <WidgetSocialShare
                            articleLink={article?.link}
                            //! DATALAYER
                            eventDataLayer={{
                              type: DATALAYER_TYPE.TRACK_POSITION,
                              router: router?.pathname,
                              section: 'share',
                              position: 'on:ภาพปก'
                            }}
                          />
                        </div>
                      </>
                    )}
                  </div>
                  {/* ------AI------ */}
                  {
                    // _article?.section?.en != 'royal-court' &&
                    <WidgetStickyContents
                      className='block-sticky'
                      isLoading={isLoading}
                      article={_article}
                      handleTranslate={handleTranslate}
                      selectLang={selectLang}
                      router={router}
                    />
                  }
                  {/* ----------------------------------- CONTENTS : ARTICLE ---------------------------------- */}

                  <div id='contents'>
                    {/*
                    {!_.isEmpty(_article?.key_point) && (
                      <div className='keypoint-wrapper'>
                        <HeadSeo
                          dangerouslySetInnerHTML={{
                            __html: `${article?.blurb || ''}`
                          }}
                        />
                        <div className='keypoint-header'>
                          <p>SHORT CUT</p>
                        </div>
                        <div
                          className='keypoint-lists'
                          dangerouslySetInnerHTML={{
                            __html: article.key_point ?? ''
                          }}
                        />
                      </div>
                    )} */}
                    {!_.isEmpty(_article.key_point) && (
                      <div className='keypoint-flex'>
                        <div id='key-point' className={`keypoint-wrapper ${isKeyPoint ? 'dis' : 'hid'}`}>
                          <HeadSeo
                            dangerouslySetInnerHTML={{
                              __html: `${_article?.blurb || ''}`
                            }}
                          />
                          <div className='keypoint-header'>
                            <p>SHORT CUT</p>
                          </div>
                          <div
                            id='keypoint-content'
                            className='keypoint-lists'
                            dangerouslySetInnerHTML={{
                              __html: _article.key_point ?? ''
                            }}
                          />
                        </div>
                      </div>
                    )}
                    {!_.isEmpty(ads) && _article?.is_show_ads && <DynamicAds position={KEY_ADS_POSITION.INARTICLE_1} data={ads} />}

                    {article?.blurb && <p className='content-blurb'>{_article.blurb}</p>}
                    <div id='paragraph'>
                      {/* ------------------------- CONTENTS I : INARTICLE 1 ------------------------- */}
                      {_article?.content_I && (
                        <div id='paragraph-1'>
                          <div
                            className='content-detail'
                            dangerouslySetInnerHTML={{
                              __html: _article?.content_I
                            }}
                          />
                          {_article?.is_show_ads && getAffiliate(1, dataAffiliate)}
                        </div>
                      )}

                      {/* ------------------------- CONTENTS II and ADS : INARTICLE 2 ------------------------ */}
                      {_article?.content_II && (
                        <div id='paragraph-2'>
                          {!_.isEmpty(ads) && _article?.is_show_ads && <DynamicAds position={KEY_ADS_POSITION.INARTICLE_2} data={ads} />}
                          <div
                            className='content-detail'
                            dangerouslySetInnerHTML={{
                              __html: _article?.content_II
                            }}
                          />
                          {_article?.is_show_ads && getAffiliate(2, dataAffiliate)}
                        </div>
                      )}
                      {/* ---------------------------- relate news: desktop -------------------------- */}
                      {!_.isEmpty(related) && (
                        <div className='widget-content related-news-desktop'>
                          <div className='widget-content-title'>
                            <div className='related-news'>เนื้อหาที่เกี่ยวข้อง</div>
                          </div>
                          <div className='block-content'>
                            <ul className='block-list'>
                              {related.slice(0, 3).map((item, index) => (
                                <li key={index}>
                                  <CardH
                                    data={item}
                                    large={false}
                                    external={false}
                                    //! DATALAYER
                                    eventDataLayer={{
                                      type: DATALAYER_TYPE.TRACK_POSITION,
                                      router: router?.pathname,
                                      section: 'เนื้อหาที่เกี่ยวข้อง',
                                      position: 'ใต้:paragraph-2',
                                      data: {
                                        block: '1',
                                        title: item?.title,
                                        heading: 'เนื้อหาที่เกี่ยวข้อง',
                                        index: index + 1
                                      }
                                    }}
                                  />
                                </li>
                              ))}
                            </ul>
                          </div>
                        </div>
                      )}
                      {/* -------------------------- CONTENTS III and ADS : INARTICLE 3 ----------------------- */}
                      {_article?.content_III && (
                        <div id='paragraph-3'>
                          {!_.isEmpty(ads) && _article?.is_show_ads && <DynamicAds position={KEY_ADS_POSITION.INARTICLE_3} data={ads} />}
                          <div
                            className='content-detail'
                            dangerouslySetInnerHTML={{
                              __html: _article?.content_III
                            }}
                          />
                          {_article?.is_show_ads && getAffiliate(3, dataAffiliate)}
                        </div>
                      )}
                    </div>

                    {/* ---------------------------- MOBILE : related  ---------------------------- */}
                    {!_.isEmpty(related) && (
                      <SlideArticle className='show-mobile show-mobile-slide mt-30'>
                        <SectionHead data='related' />
                        <Carousels dots={false} slideShow={3} mobileSlideShow={3}>
                          {related.map((item, index) => (
                            <div key={index} className='card-item card-v-item'>
                              <CardV
                                data={item}
                                pinTag={false}
                                //! DATALAYER
                                eventDataLayer={{
                                  type: DATALAYER_TYPE.TRACK_POSITION,
                                  router: router?.pathname,
                                  section: 'RELATED',
                                  position: 'after:paragraph-3',
                                  data: {
                                    block: '1',
                                    title: item?.title,
                                    heading: 'RELATED',
                                    carousel: index + 1
                                  }
                                }}
                              />
                            </div>
                          ))}
                        </Carousels>
                      </SlideArticle>
                    )}
                    {/* ----------------------------- ADS : POSTARTICLE -------------------------- */}
                    <div className='ads-postarticle'>
                      {!_.isEmpty(ads) && _article?.is_show_ads && <DynamicAds position={KEY_ADS_POSITION.POSTARTICLE} data={ads} />}
                    </div>

                    {/* ------------------------------ READ_COMPLETE ------------------------ */}
                    <div id='read-complete' className='content-tags'>
                      {!_.isEmpty(_article?.tags) && <SectionHead data='tags' />}
                      <div className='scroll-tag'>
                        {!_.isEmpty(_article?.tags) &&
                          _article.tags.map((item, index) => (
                            <a
                              key={index}
                              href={`/tags/${item}`}
                              title={item}
                              //! DATALAYER
                              onClick={() =>
                                sendDataLayerGlobal({
                                  type: DATALAYER_TYPE.TRACK_POSITION,
                                  router: router?.pathname,
                                  section: 'TAGS',
                                  position: 'after:paragraph-3',
                                  data: {
                                    block: '1',
                                    title: item,
                                    heading: 'TAGS',
                                    index: index + 1
                                  }
                                })
                              }
                            >
                              #{item}
                            </a>
                          ))}
                      </div>
                    </div>
                  </div>
                  {/* ---------------------------- DESKTOP : recommend --------------------------- */}
                  {/* {!_.isEmpty(solrRelated) && (
                    <SlideArticle className='show-desktop mt-30'>
                      <SectionHead data='recommend news' />
                      <Carousels dots={false} slideShow={3} mobileSlideShow={3} infinite={related.length < 3}>
                        {solrRelated.map((item, index) => (
                          <div key={index} className='card-item card-v-item'>
                            <CardV
                              data={item}
                              pinTag={false}
                              external={true}
                              //! DATALAYER
                              eventDataLayer={{
                                type: DATALAYER_TYPE.TRACK_POSITION,
                                router: router?.pathname,
                                section: 'RECOMMEND NEWS',
                                position: 'after:TAGS',
                                data: {
                                  block: '1',
                                  title: item?.title,
                                  heading: 'RECOMMEND NEWS',
                                  carousel: index + 1
                                }
                              }}
                            />
                          </div>
                        ))}
                      </Carousels>
                    </SlideArticle>
                  )} */}
                  {/* ------------------------------- MOBILE : recommend news ------------------------------ */}
                  {/* {!_.isEmpty(solrRelated) && (
                    <SlideArticle className='show-mobile show-mobile-slide mt-30'>
                      <SectionHead data='recommend news' />
                      <div className='row card-list'>
                        {solrRelated.slice(0, 4).map((item, index) => (
                          <div key={index} className='card-item card-v-item col-6'>
                            <CardV
                              data={item}
                              pinTag={false}
                              share={false}
                              external={true}
                              //! DATALAYER
                              eventDataLayer={{
                                type: DATALAYER_TYPE.TRACK_POSITION,
                                router: router?.pathname,
                                section: 'RECOMMEND NEWS',
                                position: 'after:TAGS',
                                data: {
                                  block: '1',
                                  title: item?.title,
                                  heading: 'RECOMMEND NEWS',
                                  index: index + 1
                                }
                              }}
                            />
                          </div>
                        ))}
                      </div>
                    </SlideArticle>
                  )} */}
                  {/* --------------------------- ADS : Native (Infinities) ----------------------------------- */}
                  {article?.is_show_ads && <AdsNative data={dataAdsNative} isShowAds={article?.is_show_ads} />}
                </div>

                {/* ---------------------------- BLOCKSIDE : START --------------------------- */}
                <div className='col-12 col-lg-3 d-none d-lg-block position-relative p-0 slide-right'>
                  <StickyBox offsetTop={100} offsetBottom={50}>
                    <div className='side-article'>
                      {!_.isEmpty(mostview) && (
                        <div className='item-right'>
                          {/* --------------------------------- DESKTOP : MOST VIEW -------------------------------- */}
                          <>
                            {/* ----------------------------- ADS : STICKY-1 -------------------------- */}
                            {!_.isEmpty(ads) && _article.is_show_ads && <DynamicAds position={KEY_ADS_POSITION.STICKY_1} data={ads} />}
                            <SectionHead data='MOST VIEW' />
                            <div className='row card-list'>
                              {mostview.map((item, index) => (
                                <div key={index} className='col-12 p-0 card-items'>
                                  <CardH
                                    data={item}
                                    pinTag={false}
                                    isH3={false}
                                    //! DATALAYER
                                    eventDataLayer={{
                                      type: DATALAYER_TYPE.TRACK_POSITION,
                                      router: router?.pathname,
                                      section: 'MOST VIEW',
                                      position: 'after:header',
                                      data: {
                                        block: '2',
                                        title: item?.title,
                                        heading: 'MOST VIEW',
                                        index: index + 1
                                      }
                                    }}
                                  />
                                </div>
                              ))}
                            </div>
                          </>
                        </div>
                      )}

                      {!_.isEmpty(related) && (
                        <>
                          {/* ----------------------------- ADS : STICKY-2 -------------------------- */}
                          {!_.isEmpty(ads) && _article.is_show_ads && <DynamicAds position={KEY_ADS_POSITION.STICKY_2} data={ads} />}
                          {/* --------------------------------- RELATED -------------------------------- */}
                          {/* <div className='item-right'>
                            <>
                              <SectionHead data='RELATED' />
                              <div className='row card-list'>
                                {related.map((item, index) => (
                                  <div key={index} className='col-12 p-0 card-items'>
                                    <CardH
                                      data={item}
                                      // external
                                      pinTag={false}
                                      //! DATALAYER
                                      eventDataLayer={{
                                        type: DATALAYER_TYPE.TRACK_POSITION,
                                        router: router?.pathname,
                                        section: 'RELATED',
                                        position: 'after:MOST VIEW',
                                        data: {
                                          block: '2',
                                          title: item?.title,
                                          heading: 'RELATED',
                                          index: index + 1
                                        }
                                      }}
                                    />
                                  </div>
                                ))}
                              </div>
                            </>
                          </div> */}

                          {/* ----------------------------- ADS : STICKY-3 -------------------------- */}
                          {!_.isEmpty(ads) && _article.is_show_ads && <DynamicAds position={KEY_ADS_POSITION.STICKY_3} data={ads} />}
                        </>
                      )}
                    </div>
                  </StickyBox>
                </div>
              </div>
              {/* ----------------------------- ADS : AD1X1 -------------------------- */}
              {!_.isEmpty(ads) && _article.is_show_ads && <DynamicAds position={KEY_ADS_POSITION.AD1X1} data={ads} />}
            </div>
          </div>
          {/* ----------------------------------- CONTENTS : End ---------------------------------- */}
        </CategoryWrapper>
      </Layout>
    </>
  );
};
const HeadSeo = styled.h2`
  position: absolute;
  visibility: hidden;
  overflow: hidden;
`;
const SlideArticle = styled.div`
  position: relative;
  padding-bottom: 30px;
  .slick-slider {
    margin: 0 -15px;
  }

  .section-head {
    /* padding-bottom: 24px;
    @media (max-width: 690px) {
      padding-bottom: 15px;
    } */
    .feed-bg {
      font-size: 20px;
    }
  }
  .card-item {
    padding: 0 15px;
    .card-v {
      &.card-thumb &.article-share {
        display: none !important;
      }
    }
  }
  .slick-slider {
    position: static;
    .slide-arrow,
    .slick-arrow {
      display: block !important;
      background-color: #fff;
      border: none;
      position: absolute;
      padding-left: 5px;
      top: 16px;
      right: 0px;
    }
    .next-arrow,
    .slick-next,
    .prev-arrow,
    .slick-prev {
      z-index: 1;
      font-size: unset;
      width: unset;
      height: unset;
      &:before {
        content: unset;
      }
      cursor: pointer;
      svg {
        vertical-align: middle;
        color: #000;
      }
    }
    .prev-arrow,
    .slick-prev {
      right: 20px;
      left: unset;
      z-index: 2;
      &:after {
        content: '/';
        padding-left: 5px;
        color: #a0a0a0;
        vertical-align: middle;
      }
    }
  }
`;
const ScrollArticle = styled.div`
  width: 90%;
  max-width: 100%;
  min-height: 200px !important;
  height: 260px !important;
  overflow: hidden !important;
  margin: 10px auto 30px auto;
  @media (min-width: 768px) {
    width: 70%;
  }
  .card-item {
    margin-bottom: 15px;
  }
`;

const CategoryWrapper = styled.div`
  background-image: ${props => `url(${props?.wrapSectionImage})`};
  background-size: 100vw;
  background-repeat: no-repeat;
  background-position: center 50px;
  .category-nation-story-logo {
    background-color: #2423c4;
    padding: 10px;
    margin-bottom: 10px;
    .logo-image {
      width: 100%; /* Or adjust based on design */
      max-width: 150px;
      padding: 10px 10px 0 10px;
    }
  }
  .keypoint-wrapper {
    display: flex;
    border-top: 7px solid var(--primary-color);
    padding: 30px 0;
    margin-top: 10px;
    border-bottom: 1px dashed var(--primary-color);

    .keypoint-header {
      margin-top: 8px;
      background-color: var(--primary-color);
      max-width: 120px;
      @media (max-width: 767px) {
        background-color: unset;
      }
      p {
        font-size: 25px;
        font-weight: bolder;
        letter-spacing: 0.4px;
        line-height: 1.05;
        padding: 15px;
        text-transform: uppercase;
      }
    }
    .keypoint-lists::after {
      content: attr(data-text);
      white-space: pre-wrap;
      overflow: hidden;
      max-width: 100%;
      animation: typewriter 4s steps(50) 1s forwards;
    }

    &.hid {
      display: none;
      opacity: 0;
      animation: typewriterReverse 6s steps(100) 0.4s normal both;
    }
    @keyframes typewriter {
      0% {
        max-height: 0;
      }
      20% {
        max-height: 50em;
      }
      100% {
        max-height: 100em;
      }
    }
    @keyframes typewriterReverse {
      100% {
        max-height: 0;
      }
      20% {
        max-height: 50em;
      }
      0% {
        max-height: 100em;
      }
    }

    ul {
      padding-left: 30px;
      @media (max-width: 767px) {
        padding-left: 15px;
        padding-top: 15px;
      }
      li {
        display: flex;
        align-items: flex-start;

        ::marker {
          font-size: 24px;
          line-height: 0;
          color: var(--primary-color);
        }
        list-style-type: disc;
        display: list-item;
        margin-left: 1.5rem;
        line-height: 1.65;
        font-size: 20px;
        a {
          letter-spacing: 0.2px;
          font-display: swap;
        }
      }
    }
    @media (max-width: 767px) {
      display: block;

      padding: 20px 0;
      margin-bottom: 30px;
      .keypoint-header {
        display: flex;
        p {
          font-size: 22px;
        }
        margin-top: 0px;
      }
      ul {
        li {
          font-size: 16px;
        }
      }
    }
  }

  .click-image-wrap {
    display: ${props => (!_.isEmpty(props?.wrapSectionImage) ? 'block' : 'none')};
    height: 20vw;
    @media (max-width: 1024px) {
      display: none;
    }
  }
  @media (max-width: 1024px) {
    background-image: unset;
  }
  .bg-section {
    background-color: white;
    padding-top: 30px;
    padding-left: 20px;
    padding-right: 20px;
    @media (max-width: 1024px) {
      padding-left: 30px;
      padding-right: 30px;
      padding-top: unset;
      background-color: unset;
    }
    @media (max-width: 768px) {
      padding-top: 60px;
    }
  }
  .headiing-line {
    text-transform: uppercase;
  }
  .slide-right {
    padding-left: 30px;
    .item-right {
      &:nth-child(1) {
        margin: 0 0 30px 0;
      }
      /* margin: 62px 0; */
      /* .solr-sticky {
        margin-top: 62px;
      } */
    }
    /* .section-head {
      padding-bottom: 24px;
      @media (max-width: 690px) {
        padding-bottom: 15px;
      }
    } */
    .card-items {
      margin-bottom: 16px;
    }
  }

  .card-v-item {
    .border-item {
      margin-top: 0;
      border-bottom: 1px solid rgba(120, 120, 120, 0.1);
      padding: 0 0 38px 0;
    }
  }

  .side-article {
    background-color: #fff;
    /* padding: 15px; */
    .feed-bg {
      font-size: 22px;
    }
    .card-v {
      padding: 0px;
    }

    .heading {
      margin-left: -3px;
    }
  }
  padding-top: 30px;
  /* twitter */
  .twitter-tweet {
    margin: auto;
  }

  .title-content {
    line-height: 1.35;
    @media (max-width: 480px) {
      padding-bottom: 10px;
    }
    h1 {
      font-size: 40px;
      font-weight: 500;
      @media (max-width: 1024px) {
        font-size: 28px;
      }
      @media (max-width: 480px) {
        line-height: 1.75;
        font-size: 26px;
      }
    }
  }

  .post-info {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 8px 0 30px 0;
    .meta {
      display: flex;
      .byline {
        color: #000000;
        &:after {
          content: '/';
          font-size: 12px;
          padding: 0 10px;
          color: #000000;
        }
        .by {
          text-transform: lowercase;
          margin-right: 5px;
        }
      }
      .date-time {
        color: #6f6f6f;
        svg {
          margin: 0 3px 0 0;
        }
      }
      p,
      span,
      svg {
        font-size: 12px;
      }
    }

    @media (max-width: 768px) {
      .meta {
        display: flex;
        .pageview {
          justify-content: flex-start;
        }
      }
    }
  }
  .content-blurb {
    font-family: 'Sarabun', sans-serif;
    color: rgba(0, 0, 28, 0.95);
    margin-bottom: 1rem;
    font-size: 20px;
    font-weight: 700;
    line-height: 1.85;
    /* padding-left: 40px; */
    margin-top: 48px;
    margin: 30px auto;
    max-width: 90%;
    @media (max-width: 768px) {
      max-width: 100%;
      border-bottom: 1px solid rgba(244, 244, 244);
      padding-bottom: 20px;
      font-size: 20px;
      /* margin: 15px 0 15px 0; */
    }
    @media (max-width: 690px) {
      padding-left: 0;
    }
  }

  .article-area {
    .accept-cookie {
      @media (min-width: 769px) {
        margin-bottom: 20px !important;
      }
    }
  }

  .content-detail {
    font-family: 'Sarabun', sans-serif;
    font-size: 18px;
    line-height: 1.85;
    font-weight: 300;
    letter-spacing: 0.25px;
    word-break: break-word;
    font-display: swap;
    /* padding-left: 40px; */
    max-width: 90%;
    margin: auto;
    @media (max-width: 767px) {
      max-width: 100%;
      padding-left: 0;
    }

    h2 {
      display: block;
      margin: 20px 0;
      font-size: 18px;
      font-weight: 500;
      color: rgb(35, 35, 35);
      width: 95%;
      line-height: 1.8;
      border-left: 8px solid var(--primary-color);
      background: linear-gradient(90deg, #f8f8f8 85%, white 100%);
      padding: 15px 15px 15px 35px;
      border-radius: 4px;
    }

    pre {
      white-space: break-spaces;
    }

    strong,
    span {
      font-weight: 700;
    }
    img {
      max-width: 100%;
      margin: 38px auto 10px auto;
      height: auto !important;
      width: 100% !important;
      @media (max-width: 690px) {
        margin: 25px auto 10px auto;
      }
    }

    p {
      line-height: 1.85;
      margin: 15px 0;
      a {
        color: #242424;
        font-weight: 700;
      }
      &:hover {
        a {
          color: #585858;
        }
      }
    }

    iframe {
      position: relative !important;
      margin: 10px auto !important;
      max-width: 100%;
      display: flex;
      min-height: 400px;
      @media (max-width: 475px) {
        min-height: unset;
      }
    }
    ol {
      li {
        list-style-type: auto !important;
      }
    }

    ul,
    ol {
      li {
        list-style-type: disc;
        display: list-item;
        margin-left: 1.5rem;
        a {
          font-weight: 300;
          letter-spacing: 0.2px;
          font-display: swap;
        }
      }
    }
    blockquote {
      @media (max-width: 480px) {
        margin: 0;
      }
    }

    blockquote > p,
    blockquote > span,
    blockquote > strong {
      background: rgb(253 255 232 / 70%);
      padding: 35px;
      /* margin: 10px; */
      /* border-left: 3px solid var(--primary-color); */
      /* @media (max-width: 768px) {
        padding: 15px 20px;
      } */
    }

    picture {
      display: block;
      max-width: 100%;
      /* max-width: 80%; */
      margin: 0 auto;
      width: 100%;
      span {
        width: 100%;
        display: block;
        position: relative;
        text-align: center;
        font-size: 13px;
        font-weight: 300;
        line-height: 1.6;
        color: rgb(117, 117, 117);
        padding: 10px;
        margin: -5px auto 15px 0px;
      }
    }
    .image-caption {
      font-weight: 400;
      font-size: 13px !important;
      font-style: italic;
      letter-spacing: 0.25px;
    }
    .affaliate-image {
      width: 80% !important;
    }

    // iframe dailymotion
    div[style='position:relative;padding-bottom:56.25%;height:0;overflow:hidden;'] > iframe {
      display: block;
      position: relative !important;
      margin: 20px auto !important;
      max-width: 100% !important;
      height: 480px;
      @media (max-width: 767px) {
        height: 190px !important;
      }
    }
    div[style='position:relative;padding-bottom:56.25%;height:0;overflow:hidden;'] {
      height: 480px !important;
      @media (max-width: 767px) {
        height: 200px !important;
      }
    }
    // iframe dailymotion end
  }

  //START TAG หน้าอ่าน ********************************
  .heading-tag {
    border-radius: 2px;
    padding: 4px 10px;
    border: 1px solid rgba(0, 0, 0);
    background-color: rgba(0, 0, 0);
    color: #fff;
    margin-right: 8px;
    font-weight: 900;
    margin-bottom: 15px;
  }
  .content-tags {
    font-size: 16px;
    margin-top: 38px;
    margin-bottom: 38px;
    .section-head {
      padding-bottom: 14px;
    }
    .scroll-tag {
      min-height: 100px;
      overflow-y: scroll;
      @media (max-width: 475px) {
        height: 200px;
      }
      &::-webkit-scrollbar {
        width: 3px;
        background-color: #f5f5f5;
      }

      &::-webkit-scrollbar-track {
        background-color: rgba(247, 247, 247, 0.9);
      }

      &::-webkit-scrollbar-thumb {
        border-radius: 50px;
        background-color: rgba(255, 230, 0, 0.7);
      }
    }
    a {
      display: inline-block;
      align-items: center;
      font-size: 16px;
      font-weight: 500;
      margin: 5px 8px 5px 0;
      background-color: var(--primary-color);
      padding: 5px 16px;
      /* box-shadow: 2px 2px 1px #000; */

      transition: all 0.5s;
      &:hover {
        color: #fff;
        background-color: rgba(0, 0, 0);
        /* box-shadow: 2px 2px 1px var(--primary-color); */
      }
    }
  }
  //END TAG หน้าอ่าน ********************************

  /* start share */
  .section-sharelink {
    .article-share {
      .social {
        display: flex;
        list-style-type: none;
        align-items: center;
        padding: 0;
        @media (max-width: 768px) {
          justify-content: center;
        }

        svg {
          circle {
            transition: all 0.5s;
          }
          &:hover {
            circle {
              fill: rgb(0, 0, 0);
            }
            path {
              fill: #fee600;
            }
          }
        }
        li:not(:first-child) {
          padding-left: 5px;
        }
      }
    }
  }
  /* end share */
  .card-h {
    .card-items {
      margin-bottom: 16px;
    }
    a {
      h3 {
        &:hover {
          text-decoration: underline;
        }
      }
    }
  }
  .solr-card-h {
    padding-right: 15px;
  }

  .solr-card-h,
  .related-card-h {
    padding-left: 3px;

    .resolution-image {
      @media (max-width: 1024px) and (min-width: 767px) {
        position: absolute !important;
      }
    }
  }
  // accept cookie
  .displayUnset {
    display: unset;
    padding: 0;
    position: sticky;
    bottom: 0;
  }

  .infographic-image {
    display: grid;
    .resolution-image {
      padding-top: unset;
      img {
        position: relative;
        width: 975px;
        max-width: 100%;
        height: 100%;
      }
    }
  }

  .content-feature {
    position: relative;
    overflow: hidden;
    .embed-responsive {
      iframe {
        border: none;
        border-radius: 3px;
        width: 100%;
        height: 400px;
        @media (max-width: 500px) {
          height: 220px;
        }
      }
    }
    .share-card {
      z-index: 1;
      @media (max-width: 690px) {
        z-index: 1;
        background-color: var(--primary-color);
        border-radius: 100%;
        padding: 3px;
        margin-top: 15px;
        width: fit-content;
        margin-bottom: 2px;
      }
      &.--desktop {
        @media (max-width: 690px) {
          display: none;
        }
      }
      &.--mobile {
        display: none;
        @media (max-width: 690px) {
          display: flex;
        }
      }
      &:hover {
        .article-share {
          left: 38px;
          @media (max-width: 690px) {
            /* bottom: -8px; */
            left: 25px !important;
          }
        }
        ul {
          li {
            opacity: 1;
          }
        }
      }
    }
    .article-share {
      transition: all 0.6s ease-in-out;
      position: absolute;
      bottom: -6px;
      left: 38px;
      @media (max-width: 690px) {
        bottom: 1px;
        /* right: 40px; */
        left: 25px !important;
        .social {
          li {
            display: inline-grid;
            button {
              display: inline-grid;
            }
          }
        }
      }
      ul {
        list-style-type: none;
        display: flex;
        justify-content: center;
        align-items: center;
        li {
          z-index: 0;
          opacity: 0;
          @media (max-width: 690px) {
            opacity: 1;
            padding: 0 2px;
            svg {
              border-radius: 100%;
              width: 22px;
              height: 22px;
            }
          }
        }
        li:nth-child(1) {
          transition: opacity 0.3s cubic-bezier(0.35, 0.7, 0.32, 0.9) 50ms, background-color 0.3s cubic-bezier(0.35, 0.7, 0.32, 0.9) 0s;
        }
        li:nth-child(2) {
          transition: opacity 0.3s cubic-bezier(0.35, 0.7, 0.32, 0.9) 0.1s, background-color 0.3s cubic-bezier(0.35, 0.7, 0.32, 0.9) 0s;
        }
        li:nth-child(3) {
          transition: opacity 0.3s cubic-bezier(0.35, 0.7, 0.32, 0.9) 0.15s, background-color 0.3s cubic-bezier(0.35, 0.7, 0.32, 0.9) 0s;
        }
        li:nth-child(4) {
          transition: opacity 0.3s cubic-bezier(0.35, 0.7, 0.32, 0.9) 0.2s, background-color 0.3s cubic-bezier(0.35, 0.7, 0.32, 0.9) 0s;
        }
      }
    }
  }
  @media (max-width: 767px) {
    .slick-slider {
      .next-arrow,
      .slick-next,
      .prev-arrow,
      .slick-prev {
        top: 30%;
      }
    }
  }

  .show-mobile-slide {
    @media (max-width: 768px) {
      .card-list {
        margin: 0 -10px;
        .card-item {
          padding: 0 10px;
          margin: 0 0 20px 0;
        }
      }
    }
    @media (max-width: 690px) {
      .slick-slider {
        position: relative;
        .slide-arrow,
        .slick-arrow {
          background-color: #000;
          position: relative;
          padding: 14px;
        }
        .next-arrow,
        .slick-next,
        .prev-arrow,
        .slick-prev {
          position: absolute;
          top: 30%;
          transform: translate(0, -30%);
          svg {
            vertical-align: middle;
            polyline {
              stroke: var(--primary-color);
            }
          }
        }
        .next-arrow,
        .slick-next {
          right: -2px;
        }
        .prev-arrow,
        .slick-prev {
          right: unset;
          left: -2px;
          z-index: 1;
          &:after {
            content: '';
          }
        }
      }
    }
  }
  .show-mobile-carousel {
    .custom-carousel .slick-arrow {
      display: none !important;
    }
  }
`;

const BreadcrumbWrapper = styled.div`
  position: sticky;
  top: 44px;
  /* margin-bottom: ${props => (!_.isEmpty(props?.wrapSectionImage) ? '20vw' : '15px')}; */
  margin-bottom: 15px;
  z-index: 10;
  @media (max-width: 1024px) {
    top: 75px;
  }
`;

export async function getServerSideProps({ req, params, query, res, resolvedUrl }) {
  const initProps = {
    statusCode: 200,
    errMessage: null,
    article: [],
    ads: [],
    related: [],
    lastNews: [],
    articleSports: [],
    solrRelated: [],
    dataAffiliate: [],
    dataAdsNative: null,
    mostview: [],
    adsHeader: null,
    wrapSectionImage: '',
    wrapSectionLink: ''
  };
  const { expires, signature } = query;
  const _type = `/${query.type || ''}`;
  let preview = '';
  let previewParams = {};
  if (expires && signature) {
    preview = '/preview';
    previewParams = {
      expires,
      signature
    };
  }

  const url = req.url;
  let uri = `contents/${rewriteTxt(params.id)}`;
  if (url.startsWith('/advertorials')) {
    uri = `contents/${params.id}${_type}`;
  } else if (url.startsWith('/pr-news')) {
    uri = `contents/${params.id}${_type}`;
  } else if (url.startsWith('/blogs')) {
    uri = `contents/${params.id}${_type}`;
  }

  if (rewriteTxt(params.id) === 'latest-news') {
    return {
      redirect: {
        destination: `${APP_URL}/category/latest-news`,
        permanent: false
      }
    };
  }

  try {
    const data = await GET('/api/datasets');
    if (data && !_.isEmpty(convertDatasets(data, 'wrap-section', false))) {
      const dataSet = convertDatasets(data, 'wrap-section', false);
      const array = convertDatasets(dataSet?.[0], 'array', true); // | undefined
      const bgImage = convertDatasets(dataSet?.[0], 'background-desktop', true);
      const link = convertDatasets(dataSet?.[0], 'link', true);

      if (!_.isEmpty(array)) {
        if (array.split(',').includes(params?.cid?.toLowerCase()) && !_.isEmpty(bgImage)) {
          initProps.wrapSectionImage = bgImage || '';
          initProps.wrapSectionLink = link || '';
        }
      }
    }

    const scriptBrowser = await GET('/api/headerAds');
    if (!_.isEmpty(scriptBrowser)) {
      initProps.adsHeader = scriptBrowser;
    }
    const resData = await GET_ARTICLES(`/api/v1.0/${uri}${preview}${convertObjPath({ ...previewParams })}`, false, true);
    const popularData = await GET('/api/v1.0/categories/popular-news');

    if (resData?.statusCode === 404 || _.isUndefined(resData)) {
      res.setHeader('location', '/');
      res.statusCode = 301;
      res.end();
    }
    // redirect url conanical
    const splitUrl = resData?.data?.canonical?.split('/');
    const splitUrlQuery = req?.url?.split('?');
    if (
      `${APP_URL}${req?.url}` !==
      `${APP_URL}/${splitUrl?.[3]}/${splitUrl?.[4]}${!_.isUndefined(splitUrl?.[5]) ? `/${splitUrl?.[5]}` : ''}${
        !_.isUndefined(splitUrl?.[6]) ? `/${splitUrl?.[6]}` : ''
      }${splitUrlQuery?.[1] ? `?${splitUrlQuery?.[1]}` : ''}`
    ) {
      res.setHeader(
        'location',
        `${APP_URL}/${splitUrl?.[3]}/${splitUrl?.[4]}${!_.isUndefined(splitUrl?.[5]) ? `/${splitUrl?.[5]}` : ''}${
          !_.isUndefined(splitUrl?.[6]) ? `/${splitUrl?.[6]}` : ''
        }${splitUrlQuery?.[1] ? `?${splitUrlQuery?.[1]}` : ''}`
      );
      res.statusCode = 301;
      res.end();
    }
    // redirect url conanical
    // }
    if (!_.isEmpty(resData?.data)) {
      initProps.article = resData?.data;
      initProps.related = resData?.related ? resData?.related.slice(0, 5) : [];
      initProps.lastNews = resData?.last_news ? resData?.last_news.slice(0, 5) : [];
      initProps.solrRelated = resData?.solrRelated ? resData?.solrRelated.slice(0, 5) : [];
      initProps.dataAffiliate = resData?.affiliate || [];
      initProps.ads = resData?.ads || [];
      initProps.dataAdsNative = resData?.adsNative || [];
      initProps.agent = req.headers['user-agent'];
    } else {
      res.setHeader('location', '/');
      res.statusCode = 301;
      res.end();
    }
    if (!_.isEmpty(popularData)) initProps.mostview = popularData ? popularData.slice(0, 5) : [];
  } catch (err) {
    console.error(`${timestamp()} ==========> ARTICLE_DETAIL ERROR : `, err.message);
    initProps.errMessage = err?.message;
    initProps.statusCode = err?.response?.status || 500;
  }

  return {
    props: initProps
  };
}

export default PageDetail;
